import { render, staticRenderFns } from "./TemplateAdd.vue?vue&type=template&id=c010b822&scoped=true"
import script from "./TemplateAdd.vue?vue&type=script&lang=js"
export * from "./TemplateAdd.vue?vue&type=script&lang=js"
import style0 from "./TemplateAdd.vue?vue&type=style&index=0&id=c010b822&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c010b822",
  null
  
)

export default component.exports